// extracted by mini-css-extract-plugin
export default {"container":"templates-authenticated-overview-module__container"};